export default {
    computed: {
        todayList() {
            return this.$store.state.today.todayList
        },
        todayStep:{
            get(){
                return this.$store.state.today.todayStep
            },
            set(val){
                this.$store.commit('today/todayStep',val)
            }
        },
        todayListNum() {
            return this.$store.getters['today/todayListNum']
        }
    },
    methods: {
        getTodayVocabulary() {
            this.$store.dispatch('getTodayVocabulary')
        },
        todayListNext() {
            this.$store.commit('today/todayListNext')
        },
        todayListBack() {
            this.$store.commit('today/todayListBack')
        }
    }
}



// WEBPACK FOOTER //
// ./src/delegate/todayDelegate.js